import React from "react";

const BarGroup = ({ label, jdValue, userValue, max, colors }) => {
  const jdHeight = jdValue === 0 || jdValue === -1 ? 1 : (jdValue / max) * 100;
  const userHeight =
    userValue === 0 || userValue === -1 ? 1 : (userValue / max) * 100;

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="flex items-end gap-2 h-40">
        {/* User */}
        <div
          className={`${colors[1]} w-[2.4rem] shadow-md rounded relative flex items-start justify-center`}
          style={{ height: `${userHeight}%` }}
        >
          <span className="absolute -top-6 text-xs text-gray-600">
            {userValue === -1 ? "N/A" : `${userValue.toFixed(1)}s`}
          </span>
        </div>

        {/* JD Level */}
        <div
          className={`${colors[0]} w-[2.4rem] shadow-md rounded relative flex items-start justify-center`}
          style={{ height: `${jdHeight}%` }}
        >
          <span className="absolute -top-6 text-xs text-gray-600">
            {jdValue.toFixed(1)}s
          </span>
        </div>
      </div>

      <p className="text-sm text-gray-500">{label}</p>
    </div>
  );
};

const Card = ({ title, jd, user, colors }) => {
  const max = Math.max(...jd, ...user);

  return (
    <div className="bg-white rounded-xl border border-[#E4E7EC] w-[27.3rem] px-9 py-8 shadow-[0_5px_10px_rgba(0,0,0,0.08)] hover:scale-[1.025] transition-all duration-300">
      <h3 className="text-[#101828] font-semibold text-lg mb-4">{title}</h3>

      {/* Legend */}
      <div className="flex gap-6 text-sm mb-5">
        <div className="flex items-center gap-2">
          <div className={`w-3 h-3 rounded-full ${colors[1]}`}></div>
          <span className="text-[#475467]">User Analytics</span>
        </div>
        <div className="flex items-center gap-2">
          <div className={`w-3 h-3 rounded-full ${colors[0]}`}></div>
          <span className="text-[#475467]">JD level Analytics</span>
        </div>
      </div>

      {/* Bars */}
      <div className="mt-10 flex justify-between items-end">
        <BarGroup
          label="Minimum"
          jdValue={jd[0]}
          userValue={user[0]}
          max={max}
          colors={colors}
        />
        <BarGroup
          label="Average"
          jdValue={jd[1]}
          userValue={user[1]}
          max={max}
          colors={colors}
        />
        <BarGroup
          label="Maximum"
          jdValue={jd[2]}
          userValue={user[2]}
          max={max}
          colors={colors}
        />
      </div>

      <p className="text-[.78rem] text-gray-500 mt-8">
        Insights: Compares the user's{" "}
        {title === "Answering Analytics" ? "answering" : "thinking"} time with
        the average across all users for the JD.
      </p>
    </div>
  );
};

const BarGraph = ({
  jdLevelAnalytics,
  userAnalytics,
  userThinkingDataPoints,
  userAnwerDataPoints,
}) => {
  const answeringJD = [
    jdLevelAnalytics?.minAnswerTime || 0,
    jdLevelAnalytics?.avgAnswerTime || 0,
    jdLevelAnalytics?.maxAnswerTime || 0,
  ];

  const answeringUser =
    userAnwerDataPoints && userAnwerDataPoints.length > 0
      ? [
          userAnalytics?.minAnswerTime || 0,
          userAnalytics?.avgAnswerTime || 0,
          userAnalytics?.maxAnswerTime || 0,
        ]
      : [-1, -1, -1];

  const thinkingJD = [
    jdLevelAnalytics?.minThinkingTime || 0,
    jdLevelAnalytics?.avgThinkingTime || 0,
    jdLevelAnalytics?.maxThinkingTime || 0,
  ];

  const thinkingUser =
    userThinkingDataPoints && userThinkingDataPoints.length > 0
      ? [
          userAnalytics?.minThinkingTime,
          userAnalytics?.avgThinkingTime,
          userAnalytics?.maxThinkingTime,
        ]
      : [-1, -1, -1];

  return (
    <div className="mt-10 flex justify-center gap-x-20 gap-y-8 flex-wrap">
      <Card
        title="Thinking Analytics"
        jd={thinkingJD}
        user={thinkingUser}
        colors={["bg-blue-200", "bg-blue-500"]}
      />
      <Card
        title="Answering Analytics"
        jd={answeringJD}
        user={answeringUser}
        colors={["bg-purple-200", "bg-purple-500"]}
      />
    </div>
  );
};

export default BarGraph;
